export default function Community() {
  const socialLinks = [
    {
      icon: 'ri-instagram-line',
      name: 'Instagram',
      handle: '@billplayapparel',
      link: '#'
    },
    {
      icon: 'ri-facebook-line',
      name: 'Facebook',
      handle: 'BillPlay Apparel',
      link: '#'
    },
    {
      icon: 'ri-twitter-x-line',
      name: 'X (Twitter)',
      handle: '@billplay',
      link: '#'
    },
    {
      icon: 'ri-tiktok-line',
      name: 'TikTok',
      handle: '@billplayapparel',
      link: '#'
    }
  ];

  return (
    <section className="py-32 px-8 bg-[#181818] border-t border-b border-[#333333]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-5 py-2 mb-8">
            <span className="text-xs font-bold text-white tracking-wide">STAY CONNECTED</span>
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight mb-8">
            Join The<br />
            Community
          </h2>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Follow us for behind-the-scenes content, drop announcements, style inspiration, and community highlights.
          </p>
        </div>

        {/* Social Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-[1200px] mx-auto">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.link}
              className="bg-[#0A0A0A] border border-[#333333] rounded-2xl p-8 text-center hover:border-white/30 hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4">
                <i className={`${social.icon} text-4xl text-white`}></i>
              </div>
              
              <div className="text-lg font-black text-white mb-2">
                {social.name}
              </div>
              
              <div className="text-sm text-gray-400">
                {social.handle}
              </div>
            </a>
          ))}
        </div>

        {/* Bottom Statement */}
        <div className="mt-20 text-center">
          <p className="text-2xl md:text-3xl text-white font-bold max-w-3xl mx-auto leading-relaxed">
            Culture over everything.<br />
            <span className="text-gray-400">We're building something real.</span>
          </p>
        </div>
      </div>
    </section>
  );
}